
const stressRanges = [
  {
    low: 0,
    high: 26,
    status: 'good',
    message: 'Descansado'
  },
  {
    low: 26,
    high: 51,
    status: 'ok',
    message: 'Estrés bajo'
  },
  {
    low: 51,
    high: 76,
    status: 'warning',
    message: 'Estrés medio'
  },
  {
    low: 76,
    high: 101,
    status: 'bad',
    message: 'Estrés alto'
  }
];

const cardiovascularHealthRanges = [
  {
    low: 0,
    high: 31,
    status: 'bad',
    message: 'Salud bajo'
  },
  {
    low: 31,
    high: 61,
    status: 'warning',
    message: 'Salud normal'
  },
  {
    low: 61,
    high: 100,
    status: 'ok',
    message: 'Salud buena'
  },
  {
    low: 100,
    high: 301,
    status: 'good',
    message: 'Salud excelente'
  }
];

const sleepScoreRanges = [
  {
    low: 0,
    high: 5,
    status: 'warning',
    message: 'Calidad de sueño bajo'
  },
  {
    low: 5,
    high: 7,
    status: 'ok',
    message: 'Calidad de sueño medio'
  },
  {
    low: 7,
    high: 10,
    status: 'good',
    message: 'Calidad de sueño excelente'
  },
];

export { stressRanges, cardiovascularHealthRanges, sleepScoreRanges }
